// Ref: https://github.paypal.com/ConsumerWeb-UI/react-i18n/blob/master/src/createi18n.js

import IntlMessageFormat from 'intl-messageformat';
import createFormatCache from 'intl-format-cache';

export default function (messages = {}, locale) {
  const i18n = {
    getMessageFormat: createFormatCache(IntlMessageFormat),

    formatMessage(message, values) {
      const locales = [locale];

      let formattedMessage;
      if (typeof message === 'function') {
        formattedMessage = message(values);
      }

      if (typeof message === 'string') {
        formattedMessage = this.getMessageFormat(message, locales, null).format(values);
      }
      return formattedMessage;
    },

    getIntlMessage(key) {
      let message;
      const keyParts = key.split('.');

      try {
        message = keyParts.reduce((obj, keyPart) => obj[keyPart], messages);
      } catch (error) {
        throw new ReferenceError(`Could not find Intl message: ${key}`);
      }
      return message;
    },

    message(key, data) {
      let message;

      if (!messages) {
        return '';
      }

      try {
        message = this.getIntlMessage(key);
      } catch (error) {
        if (window.console) {
          console.warn(error); // eslint-disable-line no-console
        }
      } finally {
        message = message || `☃${key}☃`;
      }

      if (data) {
        message = this.formatMessage(message, data);
      }

      return message;
    },

    link(key) {
      let message;

      if (!messages) {
        return '';
      }

      try {
        message = this.getIntlMessage(key);
      } catch (error) {
        message = '';
      } finally {
        message = message && message.trim();
      }

      return message;
    },
  };
  return i18n;
}
